import { ChapterMark, FadeIn } from '../components/eclora/Reveal';

const STEPS = [
    { n: '1', title: 'Inscris-toi', text: 'Entre ton prénom et ton email.' },
    { n: '2', title: 'Reçois ton Reset', text: 'Le workbook arrive directement dans ta boîte mail.' },
    { n: '3', title: 'Commence', text: 'Consacre environ 15 minutes par jour pendant 7 jours.' },
];

export default function Steps() {
    return (
        <section className="px-6 py-20 sm:px-10 lg:py-32" data-testid="steps-section">
            <div className="mx-auto max-w-5xl">
                <ChapterMark index="05" label="Le départ" />
                <FadeIn className="text-center">
                    <h2 className="font-serif text-3xl font-medium text-bordeaux sm:text-4xl lg:text-5xl">
                        Ton Éclora commence simplement.
                    </h2>
                </FadeIn>

                <div className="mt-14 grid grid-cols-1 gap-10 sm:grid-cols-3 sm:gap-6">
                    {STEPS.map((step, i) => (
                        <FadeIn key={step.n} delay={0.12 * i} className="relative text-center">
                            <div data-testid={`step-${step.n}`} className="px-4">
                                <span className="font-serif text-7xl font-light text-champagne/60">{step.n}</span>
                                <h3 className="mt-4 font-sans text-sm font-medium uppercase tracking-[0.28em] text-bordeaux">
                                    {step.title}
                                </h3>
                                <p className="mx-auto mt-3 max-w-[16rem] text-sm leading-relaxed text-cacao/85">{step.text}</p>
                            </div>
                            {i < STEPS.length - 1 && (
                                <span aria-hidden="true" className="absolute -right-3 top-8 hidden h-px w-6 bg-champagne/60 sm:block" />
                            )}
                        </FadeIn>
                    ))}
                </div>

                <FadeIn delay={0.3} className="mt-14 text-center">
                    <p className="font-script text-3xl text-champagne sm:text-4xl">
                        Une prise de conscience. Une décision. Une action. Chaque jour.
                    </p>
                </FadeIn>
            </div>
        </section>
    );
}
